// Set Overlay
export interface SetOverlayAction {
  type: "SET_OVERLAY";
  data: string;
}

export function setOverlay(overlay: string): SetOverlayAction {
  return {
    type: "SET_OVERLAY",
    data: overlay,
  };
}
